import { constants } from "../constants";

const initialState = {
  countryCodeList: [],
};

const getCountriesApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_COUNTRY_CODES:
      return {
        ...state,
        countryCodeList: action.payload,
      };
    default:
      return state;
  }
};

export default getCountriesApiReducer;
